import * as Sentry from '@sentry/nuxt'
import { projectUserContext } from '~/utils/sentry-scrubber'

/**
 * Client-side Sentry plugin.
 * Syncs authenticated user context to Sentry and clears it on logout.
 * Uses privacy-safe user projection (id + username only).
 */
export default defineNuxtPlugin(() => {
    const auth = useAuth()

    // Watch for auth changes and update Sentry user context
    watch(
        () => auth.user.value,
        (user) => {
            // Always call setUser with projected context (null for logged-out users)
            Sentry.setUser(projectUserContext(user))
        },
        { immediate: true },
    )
})
